import React, { useEffect, useState } from 'react';
// import jsonData from './../testdata.json';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import Loading from './Laoding';






function PriceSummery() {
    const navigate = useNavigate();

    const selectedAddons = useSelector((state) => state.paymentSummery.selectedAddons);
    // const calculateTotalPrice = useSelector((state) => state.paymentSummery.totalPrice);
    const fullPrice = useSelector((state) => state.paymentSummery.fullPrice);
    const monthlyPrice = useSelector((state) => state.paymentSummery.monthlyPrice);
    const monthlyRepaymentamount = useSelector((state) => state.paymentSummery.monthlyRepayment);
    const depositPrice = useSelector((state) => state.paymentSummery.depositPrice);
    const plan = useSelector((state) => state.paymentSummery.plan);
    const totalChargeCredit = useSelector((state) => state.paymentSummery.totalChargeCredit);
    const brokerFee = useSelector((state) => state.paymentSummery.brokerFee);
    const selectInsurerType = useSelector((state) => state.paymentSummery.selectInsurerType);
    const aiDepositPrice = useSelector((state) => state.paymentSummery.aiDepositPrice);
    const aiMonthlyRepayment = useSelector((state) => state.paymentSummery.aiMonthlyRepayment);
    const aitotalPrice = useSelector((state) => state.paymentSummery.aitotalPrice);
    const aiMonthlyFull = useSelector((state) => state.paymentSummery.aiMonthlyFull);
    const userData = useSelector((state) => state.user.user);
    const loading = useSelector((state) => state.user.loading);
    const userLoginType = useSelector((state) => state.user.loginType);
    const [summaryData, setSummaryData] = useState({});
    const selectAiInsurerType = useSelector((state) => state.paymentSummery.selectAiInsurerType);
    const aitotaChargeCredit = useSelector((state) => state.paymentSummery.aitotaChargeCredit);

    const currentInsurerCharge = userLoginType === "Failed Payment" || userLoginType === "Lapse" ?
        parseFloat(userData?.PaymentDetails?.Charge || "0") :
        parseFloat(userData?.PaymentDetails?.CurrentInsurerCharge || "0") === 0 ?
            parseFloat(userData?.PaymentDetails?.AlternativeInsurerCharge || "0") :
            selectAiInsurerType.type === 'alternativeInsurer' ? parseFloat(userData?.PaymentDetails?.AlternativeInsurerCharge || "0") : parseFloat(userData?.PaymentDetails?.CurrentInsurerCharge || "0");

    const isBrokerDiscount = currentInsurerCharge < 0;

    // const policyDiscount = 40.00;
    // const totalChargeForCredit = 58.80;

    useEffect(() => {
        if (userData?.PaymentDetails) {
            const currentPremium = userLoginType === "Lapse" ? parseFloat(userData.PaymentDetails.Premium || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerPremium || "0");
            const alternativePremium = parseFloat(userData.PaymentDetails.AlternativeInsurerPremium || "0");
            const premiumFailed = parseFloat(userData.PaymentDetails.Premium || "0");

            let displayData = {};

            if (!currentPremium) {
                displayData = {
                    showAlternative: true,
                    alternativePremium,
                };
            } else if (!alternativePremium || currentPremium <= alternativePremium) {
                displayData = {
                    showCurrent: true,
                    currentPremium,
                };
            } else {
                displayData = {
                    showBoth: true,
                    currentPremium,
                    alternativePremium,
                };
            }

            setSummaryData({
                premium: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : currentPremium,
                premiumTotal: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : parseFloat(userData.PaymentDetails.CurrentInsurerTotal || "0") - currentInsurerCharge,
                // policyDiscount: 40.00,
                deposit: parseFloat(userData.PaymentDetails.Deposit || "0"),
                interest: parseFloat(userData.PaymentDetails.Interest || "0"),
                payments: parseFloat(userData.PaymentDetails.Payments || "0"),
                // currentInsurerCharge: userLoginType === "Failed Payment" ? parseFloat(userData.PaymentDetails.Charge || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerCharge || "0"),
                monthlyRepayment: 43.52,
                // totalChargeForCredit: 58.80,
                ...displayData, // Merging the insurer logic
            });
        }
    }, [userData, userLoginType, summaryData, currentInsurerCharge]);
    // const summaryData = {
    //     premium: userData?.PaymentDetails?.CurrentInsurerPremium,
    //     premiumTotal: userData?.PaymentDetails?.CurrentInsurerTotal,
    //     currentInsurerCharge: userData?.PaymentDetails?.CurrentInsurerCharge,
    //     policyDiscount: 40.00,
    //     deposit: depositPrice,
    //     interest: userData?.PaymentDetails?.Interest,
    //     payments: userData?.PaymentDetails?.Payments,
    //     monthlyRepayment: monthlyRepaymentamount,
    //     totalChargeForCredit: 58.80,
    // };

    const addonPrices = {
        legal: plan.type === 'yearly' ? userData?.AddonPrices?.Legal || 0 : 1.85,
        emergency: plan.type === 'yearly' ? userData?.AddonPrices?.Emergency || 0 : 4.4,
        key: plan.type === 'yearly' ? userData?.AddonPrices?.Key || 0 : 1.85,
        gadget: plan.type === 'yearly' ? userData?.AddonPrices?.Gadget || 0 : 5.73,
    };

    // const depositAmount = summaryData.deposit;

    useEffect(() => {
        if (!userData) {
            navigate('/');
        }
    }, [userData, monthlyRepaymentamount, navigate])

    // const diffrentBetweenYearlyAndMonthly = monthlyPrice - fullPrice;
    return (<>
        {loading ? <Loading /> : null}
        <div className='price-summary price-full-page mb-0'>
            <h1 className='mb-3 mt-0'>Price Summary</h1>
            {/* {plan.type === 'yearly' ? <p className='summary-detail-text'>
            <span>You have selected to pay the premium in full. The total premium payable is £{selectAiInsurerType.type === 'alternativeInsurer' ? aiMonthlyFull : parseFloat(fullPrice).toFixed(2)} (Inclusive of Insurance Premium Tax).</span>
            <span>Please be aware, if you choose to pay by monthly instalments the total amount payable will be £{selectAiInsurerType.type === 'alternativeInsurer' ? aitotaChargeCredit :totalChargeCredit} more than the pay in full amount. This information is broken down on the table below.</span>
            </p>:
            <p className='summary-detail-text'>
            <span>You have selected to pay by Direct Debit. A deposit of £{selectAiInsurerType.type === 'alternativeInsurer' ? aiDepositPrice : parseFloat(depositPrice).toFixed(2)} is required followed by 11 instalments of £{selectAiInsurerType.type === 'alternativeInsurer' ? aiMonthlyRepayment : monthlyRepaymentamount.toFixed(2)} (the amounts shown include Insurance Premium Tax if applicable and interest payable). This agreement has no fixed duration.</span>
            <span>Total cost of the policy, including the {isBrokerDiscount ? "-" : ""}£{brokerFee} {isBrokerDiscount ? "Broker Discount " : "Broker Fee "} and the £0.00 Direct debit fee = £{selectAiInsurerType.type === 'alternativeInsurer' ? aiMonthlyFull : parseFloat(monthlyPrice).toFixed(2)}. Credit @ 14.00% (APR 30.06% variable).</span>
            Please be aware, if you choose to pay by monthly instalments the total amount payable will be £{selectAiInsurerType.type === 'alternativeInsurer' ? aitotaChargeCredit :totalChargeCredit} more than the pay in full amount. This information is broken down on the table below.</p> } */}
            {plan.type === 'yearly' ? (
                <p className='summary-detail-text-'>
                    <span>You have selected to pay the premium in full. The total premium payable is £{selectAiInsurerType.type === 'alternativeInsurer' ? aiMonthlyFull : parseFloat(fullPrice).toFixed(2)} (Inclusive of Insurance Premium Tax).</span>
                    <br />
                    <span>Please note: choosing monthly instalments means the overall amount payable is £{selectAiInsurerType.type === 'alternativeInsurer' ? aitotaChargeCredit : totalChargeCredit} more than the paying in full. A full breakdown is shown in the table below.</span>
                </p>
            ) : (
                <p className='summary-detail-text-'>
                    {/* <span>You’ve chosen to pay for your policy by monthly instalments, giving you the flexibility to spread the cost rather than paying in full upfront.</span>
                    <br />
                    <span>The instalment facility is arranged through PremFina Ltd, subject to status, and a basic credit check will be carried out.</span>
                    <br />
                    <span>Choosing monthly instalments means the overall amount payable will be £{selectAiInsurerType.type === 'alternativeInsurer' ? aitotaChargeCredit : totalChargeCredit} more than paying in full, with a full breakdown shown in the table below.</span>
                    <br />
                    <span>Please review the pre-contract terms and confirm your consent to proceed.</span> */}
                </p>
            )}
            <Table striped hover>
                <thead>
                    <tr>
                        <th></th>
                        <th className={plan.type === 'monthly' ? 'd-none' : null}>Pay in Full</th>
                        <th className={plan.type === 'yearly' ? 'd-none' : null}>Pay Monthly</th>
                    </tr>
                </thead>
                <tbody>
                    {/* --- Premium --- */}
                    {userLoginType === "Failed Payment" ? (
                        <tr>
                            <td>Premium</td>
                            <td className={plan.type === 'monthly' ? 'd-none' : null}>£{summaryData.premium}</td>
                            <td className={plan.type === 'yearly' ? 'd-none' : null}>£{summaryData.premium}</td>
                        </tr>
                    ) : (
                        <>
                            {summaryData.showCurrent && (
                                <tr>
                                    <td>Premium</td>
                                    <td className={plan.type === 'monthly' ? 'd-none' : null}>£{summaryData.currentPremium}</td>
                                    <td className={plan.type === 'yearly' ? 'd-none' : null}>£{summaryData.currentPremium}</td>
                                </tr>
                            )}
                            {summaryData.showAlternative && (
                                <tr>
                                    <td>Alternative Premium</td>
                                    <td className={plan.type === 'monthly' ? 'd-none' : null}>£{summaryData.alternativePremium}</td>
                                    <td className={plan.type === 'yearly' ? 'd-none' : null}>£{summaryData.alternativePremium}</td>
                                </tr>
                            )}
                            {summaryData.showBoth && (
                                <tr>
                                    <td>{selectInsurerType.type === 'currentInsurer' ? 'Premium' : 'Alternative Premium'}</td>
                                    <td className={plan.type === 'monthly' ? 'd-none' : null}>
                                        £{selectInsurerType.type === 'currentInsurer' ? summaryData.currentPremium : summaryData.alternativePremium}
                                    </td>
                                    <td className={plan.type === 'yearly' ? 'd-none' : null}>
                                        £{selectInsurerType.type === 'currentInsurer' ? summaryData.currentPremium : summaryData.alternativePremium}
                                    </td>
                                </tr>
                            )}
                        </>
                    )}

                    {/* --- Broker Fee --- */}
                    <tr>
                        <td>{isBrokerDiscount ? "Broker Discount " : "Broker Fee "}</td>
                        <td className={plan.type === 'monthly' ? 'd-none' : null}>{isBrokerDiscount ? "-" : ""}£{Math.abs(currentInsurerCharge).toFixed(2)}</td>
                        <td className={plan.type === 'yearly' ? 'd-none' : null}>{isBrokerDiscount ? "-" : ""}£{Math.abs(currentInsurerCharge).toFixed(2)}</td>
                    </tr>

                    {/* --- Monthly-Only Rows --- */}
                    {plan.type !== 'yearly' && (
                        <>
                            <tr>
                                <td>Instalment Fee</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>£5.00</td>
                            </tr>
                            <tr>
                                <td>Deposit</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>
                                    £{summaryData.showBoth ? (selectInsurerType.type === 'currentInsurer' ? depositPrice.toFixed(2) : aiDepositPrice) : depositPrice.toFixed(2)}
                                </td>
                            </tr>
                            <tr>
                                <td>1st monthly repayment</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>
                                    £{summaryData.showBoth ? (selectInsurerType.type === 'currentInsurer' ? (parseFloat(monthlyRepaymentamount) + 5).toFixed(2) : (parseFloat(aiMonthlyRepayment) + 5).toFixed(2)) : (parseFloat(monthlyRepaymentamount) + 5).toFixed(2)}
                                </td>
                            </tr>
                            <tr>
                                <td>10 monthly repayments</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>
                                    £{summaryData.showBoth ? (selectInsurerType.type === 'currentInsurer' ? monthlyRepaymentamount.toFixed(2) : aiMonthlyRepayment) : monthlyRepaymentamount.toFixed(2)}
                                </td>
                            </tr>
                            <tr>
                                <td>Interest Rate</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>14%</td>
                            </tr>
                            <tr>
                                <td>Total Charge for Credit</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>£{selectAiInsurerType.type === 'alternativeInsurer' ? aitotaChargeCredit : totalChargeCredit}</td>
                            </tr>
                            <tr>
                                <td>APR (Variable)</td>
                                <td className={plan.type === 'monthly' ? 'd-none' : null}>-</td>
                                <td className={plan.type === 'yearly' ? 'd-none' : null}>29.24%</td>
                            </tr>
                        </>
                    )}

                    {/* --- Total Amount Payable --- */}
                    {summaryData.showBoth ? (
                        <tr>
                            <td><strong>Total Amount Payable</strong></td>
                            <td className={plan.type === 'monthly' ? 'd-none' : null}><strong>£{selectInsurerType.type === 'currentInsurer' ? parseFloat(fullPrice).toFixed(2) : aitotalPrice}</strong></td>
                            <td className={plan.type === 'yearly' ? 'd-none' : null}><strong>£{selectInsurerType.type === 'currentInsurer' ? parseFloat(monthlyPrice).toFixed(2) : aiMonthlyFull}</strong></td>
                        </tr>
                    ) : (
                        <tr>
                            <td><strong>Total Amount Payable</strong></td>
                            <td className={plan.type === 'monthly' ? 'd-none' : null}><strong>£{parseFloat(fullPrice).toFixed(2)}</strong></td>
                            <td className={plan.type === 'yearly' ? 'd-none' : null}><strong>£{parseFloat(monthlyPrice).toFixed(2)}</strong></td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    </>);
}





export default PriceSummery;